/**
 * GUPM-302 — as palavras que o aviso de versão e o boundary de chunk compartilham.
 *
 * Dois componentes anunciam o MESMO assunto por caminhos diferentes: o `AvisoNovaVersao`
 * avisa ANTES da falha; o `ChunkErrorBoundary` segura SE a falha vier primeiro. Quem
 * ignorou o banner e depois bateu no boundary vê as duas telas — se elas chamarem a
 * mesma coisa por dois nomes ("disponível" × "publicada"), lê como dois problemas.
 *
 * Até aqui as palavras eram literais coladas nos dois arquivos, com um comentário em
 * cada pedindo que fossem iguais. Comentário não é executável; constante é.
 *
 * ## Por que um módulo próprio e não `AvisoNovaVersao.tsx`
 *
 * O aviso importa o `useNovaVersao`, que importa o `react-router-dom`. Ler as palavras
 * de lá faria o boundary — que existe justamente para funcionar quando o resto quebrou —
 * carregar o roteador junto. Módulo sem dependência nenhuma não tem esse custo.
 *
 * ## Por que não em `src/domain/`
 *
 * O domínio é regra de negócio portável (`deploy.ts` decide o que É versão nova). Texto
 * de tela é apresentação: muda com o dono do produto, não com a regra.
 */

/**
 * Título das duas telas. "Nova versão disponível" e não "publicada"/"atualização": o
 * assunto é a versão que a PESSOA pode passar a usar, não o ato de publicar.
 */
export const TITULO_NOVA_VERSAO = 'Nova versão disponível';

/**
 * Rótulo do botão dos dois lados. "Recarregar página" e não "Recarregar"/"Atualizar":
 * neste app "atualizar" é lido como buscar leituras novas de instrumento. Dizer "página"
 * separa da linguagem do domínio.
 */
export const ROTULO_RECARREGAR = 'Recarregar página';
